import {
  GET_FOOD_SHIFT_REPORT_LIST,
  GET_FOOD_SHIFT_REPORT_LIST_SUCCESS,
  GET_FOOD_SHIFT_REPORT_LIST_FAILURE,
  SEARCH_FOOD_SHIFT_REPORT,
  SEARCH_FOOD_SHIFT_REPORT_SUCCESS,
  SEARCH_FOOD_SHIFT_REPORT_FAILURE,
} from "./actionType";

//GET_FOOD_SHIFT_REPORT_LIST
export const getFoodShiftReportList = () => {
  return {
    type: GET_FOOD_SHIFT_REPORT_LIST,
  };
};

export const getFoodShiftReportListSuccess = (data) => {
  return {
    type: GET_FOOD_SHIFT_REPORT_LIST_SUCCESS,
    payload: data,
  };
};

export const getFoodShiftReportListFailure = (error) => {
  return {
    type: GET_FOOD_SHIFT_REPORT_LIST_FAILURE,
    payload: error,
  };
};

//SEARCH_FOOD_SHIFT_REPORT
export const searchFoodShiftReport = (search) => {
  return {
    type: SEARCH_FOOD_SHIFT_REPORT,
    payload: search,
  };
};

export const searchFoodShiftReportSuccess = (data) => {
  return {
    type: SEARCH_FOOD_SHIFT_REPORT_SUCCESS,
    payload: data,
  };
};

export const searchFoodShiftReportFailure = (error) => {
  return {
    type: SEARCH_FOOD_SHIFT_REPORT_FAILURE,
    payload: error,
  };
};
